module.exports = __webpack_public_path__ + "img/icon_home_linequan@2x.e926138f.png";